import { __decorate, __metadata } from "tslib";
import { inject, singleton } from 'mana-syringe';
import { CanvasConfig } from '../types';
import { RenderingPluginContribution } from '../services/RenderingService';
import { RenderingContext, RenderReason } from '../services/RenderingContext';
/**
 * Filter dirty renderables and calculate the "dirty rectangle" which will be clear when frame began
 */

var DirtyCheckPlugin =
/** @class */
function () {
  function DirtyCheckPlugin() {}

  DirtyCheckPlugin_1 = DirtyCheckPlugin;

  DirtyCheckPlugin.prototype.apply = function (renderingService) {
    var _this = this;

    renderingService.hooks.prepare.tap(DirtyCheckPlugin_1.tag, function (object) {
      if (object) {
        var enableDirtyRectangleRendering = _this.canvasConfig.renderer.getConfig().enableDirtyRectangleRendering;

        var renderable = object.renderable;

        var isDirty = renderable.dirty || _this.renderingContext.renderReasons.has(RenderReason.CAMERA_CHANGED);

        if (isDirty || !enableDirtyRectangleRendering) {
          return object;
        } else {
          return null;
        }
      }

      return object;
    });
  };

  var DirtyCheckPlugin_1;
  DirtyCheckPlugin.tag = 'DirtyCheckPlugin';

  __decorate([inject(CanvasConfig), __metadata("design:type", Object)], DirtyCheckPlugin.prototype, "canvasConfig", void 0);

  __decorate([inject(RenderingContext), __metadata("design:type", Object)], DirtyCheckPlugin.prototype, "renderingContext", void 0);

  DirtyCheckPlugin = DirtyCheckPlugin_1 = __decorate([singleton({
    contrib: RenderingPluginContribution
  })], DirtyCheckPlugin);
  return DirtyCheckPlugin;
}();

export { DirtyCheckPlugin };